import React, { FunctionComponent } from 'react';
import { I18n } from 'common/i18n';
import { ForgeCard, ForgeButton, ForgeIcon, ForgeIconButton, ForgeLabelValue } from '@tylertech/forge-react';
import optionallyLocalizeUrls from '../../utils/optionally_localize_urls';
import {
  canCreateStories,
  canCreateMeasures,
  canCreateDatasets,
  canCreateESRIMapLayers,
} from '../../utils/site_chrome_rights';
import FeatureFlags from 'common/feature_flags';
import './index.scss';

interface MobileCreateAssetsDialogProps {
  open: boolean;
  closeDrawerCallback: () => void;
}

const MobileCreateAssetsDialog: FunctionComponent<MobileCreateAssetsDialogProps> = ({
  open,
  closeDrawerCallback,
}) => {
  const scope = 'shared.site_chrome.forge_omnibar.create_assets';

  const label = FeatureFlags.value('flexible_layout_stories_only_tir_domains')
    ? I18n.t(`${scope}.report.label`)
    : I18n.t(`${scope}.story.label`);

  return open ? (
    <div className="mobile-create-assets-drawer">
      <div className="mobile-create-assets-drawer-header">
        <ForgeIconButton
          id="close-more-action-page"
          aria-label="View user profile"
          className="tyler-icons"
          onClick={() => closeDrawerCallback()}
        >
          <ForgeIcon name="close" />
        </ForgeIconButton>
      </div>
      <div className="create-assets-dialog">
        <h1 className="forge-typography--heading4">{I18n.t(`${scope}.heading`)}</h1>
        <div className="create-assets-cards">
          {canCreateDatasets() && (
            <ForgeCard raised={true}>
              <img src="https://cdn.forge.tylertech.com/v1/images/spot/data-table-spot.svg" alt="" />
              <ForgeLabelValue>
                <div slot="label" className="forge-typography--heading2">
                  {I18n.t(`${scope}.dataset.label`)}
                </div>
                <div slot="value" className="forge-typography--label1">
                  {I18n.t(`${scope}.dataset.description`)}
                </div>
              </ForgeLabelValue>
              <div className="select-button">
                <ForgeButton
                  id="forge-create-dataset-button"
                  variant="raised"
                  onClick={() => (location.href = optionallyLocalizeUrls('/datasets/new'))}
                >
                  {I18n.t(`${scope}.select`)}
                </ForgeButton>
              </div>
            </ForgeCard>
          )}
          {canCreateStories() && (
            <ForgeCard raised={true}>
              <img src="https://cdn.forge.tylertech.com/v1/images/spot/designer-spot.svg" alt="" />
              <ForgeLabelValue>
                <div slot="label" className="forge-typography--heading2">
                  {label}
                </div>
                <div slot="value" className="forge-typography--label1">
                  {I18n.t(`${scope}.story.description`)}
                </div>
              </ForgeLabelValue>
              <div className="select-button">
                <ForgeButton
                  id="forge-create-story-button"
                  variant="raised"
                  onClick={() => (location.href = optionallyLocalizeUrls('/stories/new'))}
                >
                  {I18n.t(`${scope}.select`)}
                </ForgeButton>
              </div>
            </ForgeCard>
          )}
          {canCreateMeasures() && (
            <ForgeCard raised={true}>
              <img src="https://cdn.forge.tylertech.com/v1/images/spot/chart-spot.svg" alt="" />
              <ForgeLabelValue>
                <div slot="label" className="forge-typography--heading2">
                  {I18n.t(`${scope}.measure.label`)}
                </div>
                <div slot="value" className="forge-typography--label1">
                  {I18n.t(`${scope}.measure.description`)}
                </div>
              </ForgeLabelValue>
              <div className="select-button">
                <ForgeButton
                  id="forge-create-measure-button"
                  variant="raised"
                  onClick={() => (location.href = optionallyLocalizeUrls('/measures/new'))}
                >
                  {I18n.t(`${scope}.select`)}
                </ForgeButton>
              </div>
            </ForgeCard>
          )}
          {canCreateESRIMapLayers() && (
            <ForgeCard raised={true}>
              <img src="https://cdn.forge.tylertech.com/v1/images/spot/map-2-spot.svg" alt="" />
              <ForgeLabelValue>
                <div slot="label" className="forge-typography--heading2">
                  {I18n.t(`${scope}.esri.label`)}
                </div>
                <div slot="value" className="forge-typography--label1">
                  {I18n.t(`${scope}.esri.description`)}
                </div>
              </ForgeLabelValue>
              <div className="select-button">
                <ForgeButton
                  variant="raised"
                  onClick={() => (location.href = optionallyLocalizeUrls('/datasets/new?onlyEsri=true'))}
                >
                  {I18n.t(`${scope}.select`)}
                </ForgeButton>
              </div>
            </ForgeCard>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default MobileCreateAssetsDialog;
